import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Paper } from "@mui/material";

export const StyledGridItem = styled(Paper)`
  background-color: ${({ theme }) => theme.colors.historyBg};
  grid-row: span 1;
  border: nonw;
  padding: 1.5rem;
  border-radius: 5px;
  min-width: 100%;
  max-width: 1px;
  overflow-x: scroll;

  table {
    background-color: transparent;
  }
  
  :nth-child(1) {
    grid-row: 1/3;
  }

  .grid-item-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    color: ${({ theme }) => theme.colors.textColor};
    margin-bottom: 20px;
  }

  .grid-item-heading {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-icon {
    color: #e6e6dc;
    width: 12px;
  }

  @media ${deviceSpec.isTablet} {
    padding: 24px;

    .grid-item-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 26px;
    }
  }
`;
